import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const GUARANTEES = [
  { lead: "One all-in", rest: "rate per profile" },
  { lead: "No", rest: "recruiting fees" },
  { lead: "No", rest: "hidden costs" },
  { lead: "No", rest: "cost replacement" },
];

type NoSurprisesProps = { onQuote: () => void };

export default function NoSurprises({ onQuote }: NoSurprisesProps) {
  return (
    <section id="pricing" className="mx-auto max-w-6xl px-5 py-16 text-center sm:px-8 sm:py-24" data-testid="no-surprises-section">
      <Reveal>
        <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight text-brand-teal sm:text-5xl">
          No Surprises
        </h2>
        <p className="mt-3 font-cond text-sm font-bold uppercase tracking-[0.24em] text-brand-slate">
          One fixed price
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-5 lg:grid-cols-4">
        {GUARANTEES.map((item, i) => (
          <Reveal key={item.rest} delay={0.1 * i}>
            <div
              className="flex h-full min-h-[130px] flex-col items-center justify-center rounded-2xl border-b-8 border-brand-teal bg-brand-orange px-4 py-8 shadow-lg shadow-brand-orange/25 transition-transform duration-500 ease-out hover:-translate-y-1.5"
              data-testid={`guarantee-card-${i + 1}`}
            >
              <span className="font-cond text-xl font-bold uppercase leading-tight tracking-wide text-white">
                {item.lead}
              </span>
              <span className="mt-1 font-cond text-xs font-semibold uppercase tracking-[0.18em] text-white/85">
                {item.rest}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-14">
        <motion.button
          type="button"
          onClick={onQuote}
          data-testid="pricing-quote-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          className="rounded-full bg-brand-teal px-10 py-4 text-sm font-bold text-white shadow-xl shadow-brand-teal/30 transition-colors duration-300 hover:bg-brand-teal-dark"
        >
          Get a custom quote
        </motion.button>
      </Reveal>
    </section>
  );
}
